<template>
  <div class="custom-tab-container">
    <div
      v-for="tab in tabs"
      :key="tab.value"
      :class="[
        'custom-tab-item pointer',
        { active: tab.value === props.modelValue },
      ]"
      @click="
        () => {
          tabClick(tab.value);
        }
      "
    >
      <div class="custom-tab-label">
        {{ tab.label }}
      </div>
      <div class="custom-tab-active-indicator"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: "",
  },
  tabs: {
    type: Array,
    default: () => [],
  },
});
const emits = defineEmits(["update:modelValue", "tabClick"]);

const tabClick = (value) => {
  emits("update:modelValue", value);
  emits("tabClick", value);
};
</script>

<style>
.custom-tab-container {
  display: flex;
  align-items: center;
  background: transparent;

  .custom-tab-item {
    min-width: 48px;
    margin: 0 12px 0 0;
  }
  .custom-tab-label {
    min-width: max-content;
    min-height: 24px;
    color: rgba(255, 255, 255, 0.6);
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    width: 48px;
    
  }
  .custom-tab-active-indicator {
    width: 100%;
    height: 3px;
    border-radius: 3px;
    background: #fff;
    opacity: 0;
    margin: 4px auto 0 auto;
    width: 48px;
    max-width: 50%;
  }
  .custom-tab-item:hover {
    .custom-tab-label {
      color: rgba(255, 255, 255, 1);
    }
  }
  .custom-tab-item.active {
    .custom-tab-label {
      color: rgba(255, 255, 255, 1);
    }
    .custom-tab-active-indicator {
      opacity: 1;
    }
  }
}
</style>
